module.exports = __webpack_public_path__ + "img/BAU_Partners_15.b6783ade.jpg";